import React from 'react';

import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const RealtorCard = (props) => <Component {...transform(props)} />;

export default RealtorCard;

export { Component as component, fixtures, transform as transformer };
